import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { Button } from "react-bootstrap";
import { useMemo } from "react";

import { getRangeLabel } from "../../../helpers/dates";
import { useClassFilters } from "./ClassFilterProvider";

const buttonSize = "";

const CalendarMonthNavigator = () => {

	const {
		date,
		view,
		prevIncrement,
		nextIncrement
	} = useClassFilters();

	const rangeLabel = useMemo(() => getRangeLabel(date, view), [date, view]);

	return (
		<div className="month-navigator flex-fill d-flex d-md-block justify-content-center align-items-center">
			<Button className="text-neutral6" onClick={prevIncrement} size={buttonSize} variant="link"><ChevronLeftIcon /></Button>
			<span className="fw-bold text-neutral3">{rangeLabel}</span>
			<Button className="text-neutral6" onClick={nextIncrement} size={buttonSize} variant="link"><ChevronRightIcon /></Button>
		</div>
	);
};

export default CalendarMonthNavigator;
